var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", {}, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-sm" }),
            _vm._v(" "),
            !_vm.path
              ? _c("div", {
                  staticClass: "col-md-4",
                  domProps: { innerHTML: _vm._s(_vm.data.nextstep.noPathText) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.path
              ? _c("div", { staticClass: "col-md-5" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm.path === "radio_1177"
                    ? _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.nextstep.nextstepCareguideText
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.path === "radio_calls_sms"
                    ? _c("div", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.nextstep.nextstepCallsSmsText
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("small", {
                    staticClass: "text-muted text-center",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.nextstep.nextstepDisclaimer)
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-consent btn-primary btn-lg btn-block",
                      on: {
                        click: function($event) {
                          return _vm.logOut()
                        }
                      }
                    },
                    [_vm._v("\n          Logga ut / stäng\n        ")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c("div", {
        staticClass: "progress-bar",
        staticStyle: { width: "100%" },
        attrs: {
          role: "progressbar",
          "aria-valuenow": "100",
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ecf2d0f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ecf2d0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NextStep.vue
// module id = null
// module chunks = 